/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { OperatorDetailsDto, OperatorsListDto } from './operatorsClient.typings';
import { delayedResponse, makeMockResponse } from '../mockUtils';
import { operatorCashBoxesStatsFactory, operatorDetailsFactory, operatorDtoFactory } from './operatorsFactories';
import { CashBoxesStats } from '../cashBoxes/cashBoxesClient.typings';

const OPERATORS_LIST_URL = /\/operators$/;
const OPERATOR_DETAILS_URL = /\/operators\/\d+/;
const OPERATOR_CASHBOXES_STATS = /\/operators\/(\d+)\/cashboxes\/stats/;
const OPERATORS_HOME_URL = /\/operators\/home/;

export function addOperatorsMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onPost(OPERATORS_LIST_URL).reply((config) => {
        const body = JSON.parse(config.data);

        const data: OperatorsListDto = {
            afterKey: '2638000008',
            operators: operatorDtoFactory.list({ count: body.limit }),
        };

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 100);
    });

    mockAdapter.onGet(OPERATOR_CASHBOXES_STATS).reply((config) => {
        const data: CashBoxesStats = operatorCashBoxesStatsFactory.item();

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 100);
    });

    mockAdapter.onGet(OPERATORS_HOME_URL).reply((config) => {
        const data: OperatorDetailsDto = operatorDetailsFactory.item();

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 100);
    });

    mockAdapter.onGet(OPERATOR_DETAILS_URL).reply((config) => {
        const data: OperatorDetailsDto = operatorDetailsFactory.item();

        return delayedResponse(makeMockResponse(200, data, config), Math.random() * 100);
    });
}
